exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Progress-module__wrapper___37tJX{display:grid;gap:1rem}.Progress-module__wrapper___37tJX .Progress-module__selector___8moo3{max-width:225px}", ""]);

// exports
exports.locals = {
	"wrapper": "Progress-module__wrapper___37tJX",
	"selector": "Progress-module__selector___8moo3"
};